import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Theme, Typography } from '@mui/material';
import React, { useState, CSSProperties } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { LoadingIndicator } from './LoadingIndicator';


export const Link = styled(RouterLink)`
    text-decoration: none;
    color: ${props => props.theme.palette.primary.main};
`;

export const PseudoLink = styled.div`
    color: ${props => props.theme.palette.primary.main};
    cursor: pointer;
    font-weight: 500;
`;

export const PseudoLink2 = styled.a<{ border?: boolean }>`
    color: ${props => props.theme.palette.primary.main};
    cursor: pointer;
    font-weight: normal;
    text-decoration: none;
    border-bottom: ${props => props.border ? 1 : 0}px dotted ${props => props.theme.palette.primary.main};
    padding-bottom: ${props => props.border ? 2 : 0}px;
`;
PseudoLink2.defaultProps = { role: "button" };

export const TitleLink = styled(Link)`
    text-decoration: none;
    color: inherit;
    border-bottom: 1px dotted ${props => props.theme.palette.primary.main};
`;


export const DownloadFileLink = (props: { downloadFile: () => Promise<void> } & React.ComponentProps<typeof PseudoLink2>) => {
    const [isDownloading, setIsDownloading] = useState<boolean>(false);

    const doDownload = () => {
        setIsDownloading(true);
        props.downloadFile()
            .then(() => {
                setIsDownloading(false);
            })
            .catch(e => {
                setIsDownloading(false);
                throw e;
            })
    }

    return <PseudoLink2 {...props} onClick={doDownload}>
        {props.children} {isDownloading && <LoadingIndicator sizeVariant="s" style={{ marginLeft: "0.25rem" }} />}
    </PseudoLink2>
}


export const ItemRow = styled.div`
    display: flex;
    flex-flow: row;
    align-items: center;
    gap: 0.25rem;
`;


export interface ScrollBarStyle {
    size?: number;
}

export const scrollStyle = (theme: Theme, style?: ScrollBarStyle) => css`
    & *::-webkit-scrollbar {
        width: ${style?.size || 2}px;
        height: ${style?.size || 2}px;
        background-color: ${theme.palette.grey[200]};
    }
    & *::-webkit-scrollbar-thumb {
        background-color: ${theme.palette.primary.light};
    }
`;


export const ControlCaption = styled(Typography)`
`;
ControlCaption.defaultProps = {
  variant: "caption",
  color: "textSecondary",
  marginTop: "1rem",
};


export const FlyingSplash = styled.div<{
  anchorV?: "top" | "bottom",
  anchorH?: "left" | "right",
  positionV?: CSSProperties["bottom"],
  positionH?: CSSProperties["right"],
  }>`
  position: fixed;
  ${props => `${props.anchorV || "bottom"}: ${props.positionV || "1rem"};`}
  ${props => `${props.anchorH || "right"}: ${props.positionH || "2rem"};`}
  padding: 1rem;

  background: radial-gradient(ellipse at 40% 40%, #ffffffa0 0, #ffffff80 50%, #ffffff00 100%),
    radial-gradient(ellipse at 60% 60%, #ffffffa0 0, #ffffff80 50%, #ffffff00 100%);
`;


export const BottomFloatingPanel = styled.div`
  position: fixed;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 300;
  background: #ffffff;
  border-radius: ${props => props.theme.shape.borderRadius}px;
  box-shadow: 0 0 10px #00000040;
  padding: 0.5rem 1rem;
`;
